import React from "react";
import LogoFooter from "../../assets/images/header/logofront.svg";
import { Link } from "react-router-dom";
export default function Footer({ className }) {
  return (
    <>
      <footer className={className || "footer_section"}>
        <div className="footer-bg">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6 footer-links">
                <div className="footer-logo">
                  <img
                    src={LogoFooter}
                    className="img-footer img-fluid"
                    alt=""
                  />
                </div>
                <div className="footer-content">
                  <p className="para">
                    With a dedication to breaking down barriers and cultivating
                    a financial empowerment community, we aspire to be your
                    staunch supporters on the path to financial freedom.
                    <br></br>
                    Discover how easy it is to contact multiple lenders with a
                    single application by using our platform. Get in touch with
                    us right away!!
                  </p>
                </div>
                <div className="footer-follow">
                  <p className="follow-us">Follow us on</p>
                  <ul className="links-area">
                    <li>
                      <Link
                        to="https://www.facebook.com/finlab.oneofficial"
                        target="_blank"
                      >
                        <i
                          className="fa fa-facebook-square"
                          aria-hidden="true"
                          style={{ fontSize: "24px" }}
                        ></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://www.youtube.com/@Finlab.oneofficial"
                        target="_blank"
                      >
                        <i
                          className="fa fa-youtube-play"
                          style={{ fontSize: "24px" }}
                        ></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://www.instagram.com/finlab.oneofficial"
                        target="_blank"
                      >
                        <i
                          className="fa fa-instagram"
                          style={{ fontSize: "24px" }}
                        ></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.linkedin.com/company/finlaboneofficial">
                        <i
                          className="fa fa-linkedin-square"
                          aria-hidden="true"
                          style={{ fontSize: "24px" }}
                        ></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6  footer-links">
                <ul>
                  <li>
                    <h4>Quick Links </h4>
                  </li>
                  <li>
                    <Link to="/" title="">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/business-loan">Services</Link>
                  </li>
                  <li>
                    <Link to="/faqs">FAQs</Link>
                  </li>
                  <li>
                    <Link to="/privacypolicy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/grievance-redressal">Grievance Redressal</Link>
                  </li>
                  <li>
                    <Link to="/our-lending-partners">Lending Partners</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 footer-links">
                <ul>
                  <li>
                    <h4>Why Us?</h4>
                  </li>
                  <li>
                    <Link to="#">Easy Steps</Link>
                  </li>
                  <li>
                    <Link to="#">Low Bank Fees</Link>
                  </li>
                  <li>
                    <Link to="#">Assurance</Link>
                  </li>
                  <li>
                    <Link to="#">Our Partners</Link>
                  </li>
                  <li>
                    <h4>Legal Disclaimer</h4>
                  </li>
                  <li style={{ lineHeight: "20px" }}>
                    Finlab.One is an Loan Service Provider owned by Bynd Finserve Private Limited. We are not a lender. Loans are offered by RBI-registered Banks/NBFCs subject to approval. T&C Apply
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 footer-links">
                <ul>
                  <li>
                    <h4>Services</h4>
                  </li>
                  <li>
                    <Link to="/business-loan">Business Loan</Link>
                  </li>
                  <li>
                    <Link to="#">Supply chain finance</Link>
                  </li>
                  <li>
                    <Link to="#">Home loan</Link>
                  </li>
                  <li>
                    <Link to="#">Micro HL</Link>
                  </li>
                  <li>
                    <Link to="#">Loan against property</Link>
                  </li>
                  <li>
                    <Link to="#">Micro LAP</Link>
                  </li>
                  <li>
                    <Link to="#">Commercial purchase</Link>
                  </li>
                  <li>
                    <Link to="#">Plot purchase</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-hr"></div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                Finlab © {new Date().getFullYear()} All rights reserved.
                <div className="legal-description">
                  <span>
                    <Link to="/legal-disclaimer">Legal Disclaimer</Link>&nbsp;|&nbsp;<Link to="/terms-of-use">Terms Of Use</Link>&nbsp;|&nbsp;<Link to="/privacypolicy">Privacy Policy</Link>&nbsp;|&nbsp;<Link to="/terms-and-condition">Terms and Condition</Link>&nbsp;|&nbsp;<Link to="/">Sitemap</Link></span>
                </div>
              </div>
              <div className="col-md-6">
                Made with{" "}
                <i
                  className="fa fa-heart"
                  aria-hidden="true"
                  style={{ color: "#ff0707" }}
                ></i>{" "}
                in India |{" "} Developed By <a href="http://apisod.ai/" target="_blank" style={{color:"#f3be4e"}}>Apisod</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
